import { useState } from "react";

export function MappingPanel({ data, saveMapping, busy }) {
  const [edits, setEdits] = useState({});
  const roles = Object.entries(data.roles);
  return (
    <div className="space-y-8" data-testid="mapping-panel">
      <p className="text-sm opacity-70">Ecco come ho interpretato le colonne. Se qualcosa non è giusto, cambia il significato e salva: l'anteprima si aggiorna.</p>
      {data.mapping.map(sh => {
        const e = edits[sh.si] || {};
        const set = (col, p, cur) => setEdits({ ...edits, [sh.si]: { ...e, [col]: { role: cur.role, group: cur.group, ...e[col], ...p } } });
        return (
          <div key={sh.si} data-testid={`mapping-sheet-${sh.si}`}>
            <div className="flex items-center gap-3 mb-3">
              <div className="label-caps">Foglio «{sh.sheet}»</div>
              <span className="text-xs opacity-60">intestazioni riga {sh.header_rows.join(", ") || "—"} · dati da riga {sh.data_start_row} · {sh.source === "ai" ? "riconosciuto con AI" : "riconosciuto da parole chiave"}</span>
              {!sh.is_garment_table && <span className="text-xs text-amber-700">non sembra una tabella di capi: ignorato</span>}
            </div>
            <div className="card-dark overflow-x-auto"><table className="tbl w-full text-sm">
              <thead><tr><th>Col.</th><th>Intestazione</th><th>Esempi</th><th>Significato</th><th>Gruppo materiale</th></tr></thead>
              <tbody>{sh.columns.map(c => {
                const cur = { ...c, ...(e[c.col] || {}) };
                const isMat = data.material_roles.includes(cur.role);
                return (
                  <tr key={c.col} data-testid={`mapping-row-${sh.si}-${c.col}`}>
                    <td className="font-mono">{c.col}</td><td>{c.label || <span className="opacity-40">—</span>}</td>
                    <td className="opacity-70 text-xs">{c.samples.join(" · ") || "—"}</td>
                    <td><select className="input-dark !py-1" value={cur.role} onChange={ev => set(c.col, { role: ev.target.value }, cur)} data-testid={`mapping-role-${sh.si}-${c.col}`}>
                      {roles.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
                      {c.changed && <div className="text-[10px] text-amber-700 mt-1">modificato da te (AI: {data.roles[c.ai_role]}) <button className="underline" onClick={() => set(c.col, { role: c.ai_role, group: null }, cur)} data-testid={`mapping-reset-${sh.si}-${c.col}`}>ripristina</button></div>}</td>
                    <td>{isMat ? <input className="input-dark !py-1" list={`groups-${sh.si}`} value={cur.group || ""} onChange={ev => set(c.col, { group: ev.target.value }, cur)} data-testid={`mapping-group-${sh.si}-${c.col}`}/> : <span className="opacity-40">—</span>}</td>
                  </tr>);
              })}</tbody>
            </table></div>
            <datalist id={`groups-${sh.si}`}>{sh.groups.map(g => <option key={g.group} value={g.group}/>)}</datalist>
            <div className="flex justify-end mt-3">
              <button disabled={busy || !Object.keys(e).length} onClick={async () => {
                const all = Object.fromEntries(sh.columns.filter(c => c.changed).map(c => [c.col, { role: c.role, group: c.group }]).concat(Object.entries(e)));
                const keep = Object.fromEntries(Object.entries(all).filter(([col, v]) => { const c = sh.columns.find(x => x.col === col); return !(v.role === c.ai_role && !data.material_roles.includes(v.role)); }));
                await saveMapping(sh.si, keep); setEdits({ ...edits, [sh.si]: {} });
              }}
                className="btn-gold" data-testid={`mapping-save-${sh.si}`}>Salva e aggiorna anteprima</button>
            </div>
          </div>);
      })}
    </div>
  );
}
